var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-skeleton-loader',_vm._b({staticClass:"skeleton-loader"},'v-skeleton-loader',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }